import {
  AccountFilterAdminColumns,
  AccountFilterColumns,
  AccountFilterModel,
  useAccountFilter,
  useCurrentWorkspace,
  useSetAccountFilter,
  useValidateAccountListOrder,
} from '@gripp/shared-logic';
import {
  ColumnsFilterScreen,
  ColumnsFilterScreenHandle,
  SlideAction,
  SlideLayout,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import { HeaderResetButton } from '../../shared/components/headerResetButton/headerResetButton';
import { AccountsComponent } from './accountsComponent';
import { AccountsFilters } from './accountsFilters';

export const AccountsFilterPage = () => {
  const filterRef = useRef<ColumnsFilterScreenHandle>(null);
  const onBackButtonPressRef = useRef<(() => void) | undefined>(undefined);
  const { workspaceId } = useParams();
  const workspace = useCurrentWorkspace(true);
  const isInWorkspace = !!(workspaceId || workspace);

  const { data: filter } = useAccountFilter();
  const { mutateAsync: setFilter } = useSetAccountFilter();
  const validateListOrder = useValidateAccountListOrder();

  const leftColumn = {
    title: 'people.menu.people',
    mainComponent: <AccountsComponent />,
    headerComponent: <AccountsFilters />,
    disableScroll: true,
  };

  const rightColumn = {
    title: 'people.menu.people',
    mainComponent: (
      <>
        <ColumnsFilterScreen
          ref={filterRef}
          mode="page"
          filter={filter}
          setFilter={setFilter}
          validateListOrder={validateListOrder}
          createDefaultFilter={() => new AccountFilterModel()}
          createFilter={(data) => new AccountFilterModel(data)}
          baseColumns={AccountFilterColumns}
          adminColumns={isInWorkspace ? undefined : AccountFilterAdminColumns}
          i18nPrefix="account.filter"
          viewResultsTranslationKey="common.apply"
          bottomBar={() => <></>}
        />
        <BackHandlerRegistrar onBackButtonPressRef={onBackButtonPressRef} />
      </>
    ),
    headerComponent: (
      <HeaderResetButton onReset={() => filterRef.current?.onReset()} />
    ),
    showBackButton: true,
    onBackButtonPress: () => onBackButtonPressRef.current?.(),
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const BackHandlerRegistrar = ({
  onBackButtonPressRef,
}: {
  onBackButtonPressRef: React.MutableRefObject<(() => void) | undefined>;
}) => {
  const navigate = useNavigate();
  const { onSlideChange } = useSlideLayout();

  onBackButtonPressRef.current = async () => {
    await onSlideChange(SlideAction.SINGLE);
    navigate('/accounts');
  };

  return null;
};
